import { JSXElement, mergeProps } from 'solid-js';
import styles from './left-nav.module.scss';
import { LeftNavLinkConfig } from '~/components/Layout/LeftNav/utils.tsx';
import Link from '~/components/Link';
import { getAppliedClasses } from '~/utils/commonUtils.ts';

type IconProps = {
  strokeWidth?: number;
  width?: number;
  height?: number;
  class?: string;
};

export default function LeftNavItem(props: LeftNavLinkConfig) {
  const merged = mergeProps({}, props);
  let IconComponent: ((p: IconProps) => JSXElement) | undefined =
    merged.iconComponent;

  const ItemLabelComponent = merged.labelComponent;

  return (
    <li>
      <Link
        class={`${styles.leftNavLink} ${getAppliedClasses({
          '!pl-[58px]': !IconComponent
        })}`}
        href={merged.href}
        activeClass={`bg-bg-muted ${styles.leftNavLinkActive}`}
        data-testid={merged.dataTestId ?? 'left-nav-item'}
      >
        {IconComponent && (
          <IconComponent
            strokeWidth={1}
            width={20}
            height={20}
            class={`mr-2`}
          />
        )}

        <ItemLabelComponent />
      </Link>
    </li>
  );
}
